import { localizationService } from '@shared-services/localization-service';
import { Customization, CustomizationValue } from './types';

const { str } = localizationService;

const getLength = (value?: CustomizationValue) => (value as string[])?.length;

const RULES = {
    required: (value?: CustomizationValue) => {
        if (Array.isArray(value)) {
            return (
                !!value?.length ||
                str(
                    'ui.runtimessr.productCustomizations.errors.checkbox.required'
                )
            );
        }

        return (
            !!value ||
            str('ui.runtimessr.productCustomizations.errors.required')
        );
    },
    minChoices: (min: number) => (value?: CustomizationValue) =>
        getLength(value) >= min ||
        str('ui.runtimessr.productCustomizations.errors.checkbox.minChoices', {
            min: min.toString(),
        }),
    maxChoices: (max: number) => (value?: CustomizationValue) =>
        getLength(value) <= max ||
        str('ui.runtimessr.productCustomizations.errors.checkbox.maxChoices', {
            max: max.toString(),
        }),
    exactlyChoices: (exactly: number) => (value?: CustomizationValue) => {
        const choicesLength = getLength(value);
        const isValid = choicesLength === exactly;

        return (
            isValid ||
            str(
                'ui.runtimessr.productCustomizations.errors.checkbox.exactlyChoices',
                {
                    exactly: exactly.toString(),
                }
            )
        );
    },
};

export const buildValidationSchema = (customizations: Customization[]) =>
    customizations.reduce((acc, { id, mandatory, limitations }) => {
        if (!acc[id]) {
            acc[id] = [];
        }

        const targetValidation = acc[id];

        if (mandatory) {
            targetValidation.push(RULES.required);
        }

        if (limitations) {
            if (limitations.min_choices && limitations.max_choices) {
                targetValidation.push(
                    RULES.exactlyChoices(limitations.min_choices)
                );
            } else if (limitations.min_choices) {
                targetValidation.push(
                    RULES.minChoices(limitations.min_choices)
                );
            } else if (limitations.max_choices) {
                targetValidation.push(
                    RULES.maxChoices(limitations.max_choices)
                );
            }
        }

        return acc;
    }, {} as Record<string, Array<(value: CustomizationValue) => boolean | string>>);
